
import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';
import { ROUTE } from 'constant';
import { _t, getKey, toCurrency } from 'utils';
import { useSelector } from 'react-redux';
import { ACTIONS_TYPES } from 'redux/helper';

export const InvoiceCurrent = ({ history }) => {
  const { [ACTIONS_TYPES.BILLING.GET_USAGE]: usage = {}, [ACTIONS_TYPES.BILLING.GET_PRODUCTS]: productsBilling = {} } = useSelector((e) => e);
  const { products = [] } = productsBilling;
  let { datacenters = [] } = usage;

  datacenters = datacenters.map(({ id, name, meters }) => {
    const total = meters.reduce(({ price }, meter) => {
      const { meterDesc = '', meterId = '', quantity = {} } = meter;
      const { unitCost = {} } = products.find((e) => e.meterId === meterId) || {};
      const totalPrice = quantity?.quantity * unitCost?.quantity;

      return { price: price + totalPrice, unit: unitCost?.unit, meterDesc };
    }, { price: 0, unit: '', meterDesc: '' });

    return { id, name, total };
  });

  const grandTotalPrice = datacenters.reduce((grandTotal, { total }) => grandTotal + total.price, 0) || 0;
  const [firstDC = {}] = datacenters;

  useEffect(() => {
    const contractId = getKey('selectedContractId');
    actions.billing.getProducts({ contractId });
    actions.billing.getUsage({ contractId });
  }, []);

  return (
    <Shared.widgets.Page route={ROUTE.DASHBOARD.INVOICE_CURRENT} isStrap={false}>
      <Shared.widgets.Section
        sectionTitle="Data Centers"
        items={datacenters}
        className="-m-t-24"
        itemIcon="boxes"
        setItemTitle={(e) => e?.name || e?.total?.meterDesc || ''}
        setItemDetails={(e) => `${toCurrency(e?.total?.price || 0)} ${e?.total?.unit || 0}`}
        itemOnClick={(e) => history.push(ROUTE.DASHBOARD.INVOICE_CURRENT_DATA_CENTER.path.replace(':datacenterId', e?.id))}
        tableColumns={['', 'Name', 'Amount']}
      />
      <hr />
      <div className="flex flex-column">
        <span>{`Total: ${toCurrency(grandTotalPrice)} ${firstDC?.total?.unit || ''}`}</span>
        <span className="f-14 color-danger m-t-5">{`* ${_t('Excluding VAT. Additional discounts may apply')}`}</span>
      </div>
    </Shared.widgets.Page>
  );
};
